<template>
  <div>
    <select v-model="val" @change="change" class="form-control">
      <option v-for="(course, key) in courses" :key="key" :value="course">
        {{ key }}
      </option>
    </select>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Search",
  data() {},
  props: ["value"],
  methods: {
    change(e) {},
  },
  computed: {
    ...mapState(["courses"]),
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>